export const organizationFr = {
    admin: {
        actions: {
            dissociateDeviceMessage: 'Êtes-vous sûr de vouloir dissocier cet appareil de {name} ?'
        },
        detail: {
            actionsTitle: 'Actions',
            informationsTitle: 'Informations',
            localizationTitle: 'Localisation'
        },
        model: {
            name: 'Nom',
            socialReason: 'Raison sociale',

            street: 'Rue',
            zipCode: 'Code postal',
            city: 'Ville',
            country: 'Pays'
        },
        table: {
            id: 'ID',
            name: 'Nom',
            createOrganization: 'Ajouter une entreprise'
        }
    },
    api: {
        error: {
            createOrganization: "Erreur lors de la création de l'entreprise {name}",
            deleteOrganization: "Erreur lors de la suppression de l'entreprise {name}",
            fetchOrganization: "Erreur lors de la récupération de l'entreprise",
            fetchOrganizations: 'Erreur lors de la récupération des entreprises',
            updateOrganization: "Erreur lors de la modification de l'entreprise {name}",

            createUser: "Erreur lors de la création de l'utilisateur {name}",
            initOrganizationWithUser:
                "Erreur lors de la création de l'utilisateur {name} et de l'organisation",

            fetchMyOrganization: 'Erreur lors de la récupération de mon entreprise',
            fetchOrganizationUsers:
                'Erreur lors de la récupération des utilisateurs de mon entreprise',
            fetchOrganizationApis: 'Erreur lors de la récupération des APIs de mon entreprise',
            attachUserToOrganization: "Erreur lors du rattachement de l'utilisateur à l'entreprise",
            detachUserFromOrganization:
                "Erreur lors du détachement de l'utilisateur à l'entreprise",
            fetchOrganizationDevices:
                "Erreur lors de la récupération de l'appareil de mon entreprise",
            attachDeviceToOrganization: "Erreur lors du rattachement de l'appareil à l'entreprise",
            detachDeviceFromOrganization: "Erreur lors du détachement de l'appareil à l'entreprise",

            createApi: 'Erreur lors de la création de la clé API {name}',
            updateApi: 'Erreur lors de la modification de la clé API {name}'
        },
        success: {
            createOrganization: "Création de l'entreprise {name} effectuée avec succès !",
            deleteOrganization: "Suppression de l'entreprise {name} effectuée avec succès !",
            fetchOrganization: "Récupération de l'entreprise effectuée avec succès !",
            fetchOrganizations: 'Récupération des entreprises effectuée avec succès !',
            updateOrganization: "Modification(s) de l'entreprise {name} effectuée(s) avec succès !",

            createUser: "Création de l'utilisateur {name} effectuée avec succès !",
            initOrganizationWithUser:
                "Création de l'utilisateur {name} et initialisation de l'organisation effectuées avec succès !",

            fetchMyOrganization: 'Récupération de mon entreprise effectuée avec succès !',
            fetchOrganizationUsers:
                "Récupération des utilisateurs de l'entreprises effectuée avec succès !",
            fetchOrganizationApis: "Récupération des APIs de l'entreprises effectuée avec succès !",
            attachUserToOrganization:
                "Rattachement de l'utilisateur à l'entreprise effectuée avec succès !",
            detachUserFromOrganization:
                "Détachement de l'utilisateur à l'entreprise effectuée avec succès !",
            fetchOrganizationDevices:
                "Récupération des appareils de l'entreprise effectuée avec succès !",
            attachDeviceToOrganization:
                "Rattachement de l'appareil à l'entreprise effectuée avec succès !",
            detachDeviceFromOrganization:
                "Détachement de l'appareil à l'entreprise effectuée avec succès !",

            createApi: 'Création de la clé API {name} effectuée avec succès !',
            updateApi: 'Modification de la clé API {name} effectuée avec succès !'
        }
    },
    buttons: {
        associateAnUser: 'Associer un utilisateur',
        dissociateAnUser: 'Dissocier un utilisateur',
        associateUser: "Associer l'utilisateur",
        dissociateUser: "Dissocier l'utilisateur",
        associateDevice: "Associer l'appareil",
        dissociateDevice: "Dissocier l'appareil"
    },
    filters: {
        deactivated: 'Uniquement les utilisateurs désactivés'
    },
    organizations: {
        api: {
            error: {
                updateOrganization: "Erreur lors de la modification de l'entreprise {name}"
            },
            success: {
                updateOrganization:
                    "Modification(s) de l'entreprise {name} effectuée(s) avec succès !"
            }
        },
        buttons: {
            invitations: 'Invitations'
        },
        invite: {
            addFriendCode: 'Ajouter un code ami',
            friendCode: 'Code ami',
            inviteLink: "Lien d'invitation",
            yourFriendCode: 'Votre code ami',
            yourLink: "Votre lien d'invitation",
            qrCode: 'QR Code'
        },
        table: {
            id: 'ID',
            name: 'Nom complet',
            email: 'Email',
            roles: 'Rôles'
        }
    },
    informations: {
        general: 'Général'
    },
    model: {
        id: 'ID',
        name: 'Nom',
        socialReason: 'Raison sociale',
        organizationId: "ID de l'organisation",
        deviceId: "ID de l'appareil",
        userId: "ID de l'utilisateur"
    },
    networks: {
        invitation: {
            invitedBy:
                "{recipient}, vous avez été invité à rejoindre le réseau de {sender} afin d'autoriser la location des appareils. Voulez-vous le rejoindre ?"
        },
        invites: {
            removeInvite: "Annuler l'invitation",
            revokeAccess: 'Retirer des partenaires',
            noReceivedInviteCurrently: 'Aucune invitation reçue actuellement',
            noSentInviteCurrently: 'Aucune invitation envoyée actuellement',
            email: 'Email du destinataire',
            generateInvitation: 'Envoyer une invitation',
            receivedInvites: 'Invitations reçues',
            sentInvites: 'Invitations envoyées',
            declineInvite: 'Refuser',
            acceptInvite: 'Accepter'
        }
    },
    users: {
        buttons: {
            associateUser: 'Associer un utilisateur existant',
            createUser: 'Créer un utilisateur'
        },
        roles: 'Rôles'
    },
    title: {
        associateUserTitle: 'Associer un utilisateur à une organisation',
        dissociateUserTitle: "Dissocier un utilisateur d'une organisation",

        associateDeviceTitle: 'Associer un appareil à une organisation',
        dissociateDeviceTitle: "Dissocier un appareil d'une organisation",

        myOrganization: "Gestion d'entreprise"
    },
    tabs: {
        devicesTitle: 'Appareils',
        informationsTitle: 'Informations',
        networksTitle: 'Clients',
        rolesTitle: 'Rôles',
        usersTitle: 'Utilisateurs',
        apisTitle: 'Apis'
    }
}
